export class TitleSearch {
    frames: NodeListOf<HTMLFormElement>;

    constructor() {
        this.frames = document.querySelectorAll('[data-title-search-frame]');
        this.init();
    }

    init() {
        this.addEventListeners()
    }

    addEventListeners() {
        this.frames.forEach((frame) => {
            const form: HTMLFormElement = frame.querySelector('[data-title-search-form]'),
                loading: HTMLElement = frame.querySelector('[data-title-search-loading]');

            frame.addEventListener('turbo:frame-load', () => {
                const form: HTMLFormElement = frame.querySelector('[data-title-search-form]'),
                    fields: NodeListOf<HTMLElement> = form.querySelectorAll('[data-title-search-field]'),
                    loading: HTMLElement = frame.querySelector('[data-title-search-loading]');

                fields.forEach((field) => {
                    field.addEventListener('change', () => {
                        loading.classList.remove('d-none');
                        form.requestSubmit();
                    });
                });
            });

            loading.classList.remove('d-none');
            form.requestSubmit();
        });
    }

}
document.addEventListener("DOMContentLoaded", function() {
    new TitleSearch();
});
